const descriptions: Record<string, string> = {
  'Physical Resistance': 'Combat bonuses from physical weapons are halved, rounded up.',
  'Magical Resistance': 'Combat bonuses from magical weapons and spells are halved, rounded up.',
  'Physical Immunity': 'Combat bonuses from physical weapons do not apply.',
  'Magical Immunity': 'Combat bonuses from magical weapons and spells do not apply.',
  'Weapon Immunity': 'Combat bonuses from weapons do not apply. Other Combat bonuses can still apply.',
  Ambush: 'After you begin fighting this monster, you cannot flee. You may still attempt to evade it before fighting.',
  Undead: 'This monster is Undead. Effects that specifically affect Undead monsters apply to it.',
  Mask: 'A Mask monster associated with Nyarlathotep. Apply the monster’s printed special rules.',
  Endless: 'When defeated, return this monster to the monster cup instead of taking it as a trophy.',
  Elusive: 'You may ignore this monster. To fight it, first pass an Evade check against its Awareness.',
};

export function monsterAbilityDescription(ability: string): string | undefined {
  const numbered = /^(Nightmarish|Overwhelming)\s+(\d+)$/i.exec(ability.trim());
  if (numbered) return numbered[1].toLowerCase() === 'nightmarish'
    ? `Lose ${numbered[2]} Sanity even if you pass the Horror check.`
    : `Lose ${numbered[2]} Stamina even if you pass the Combat check.`;
  const name = Object.keys(descriptions).find(value => value.toLowerCase() === ability.trim().toLowerCase());
  return name ? descriptions[name] : undefined;
}
